var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bd-cell",class:{
    active: _vm.index + 1 == _vm.activeRowIndex,
  }},[_vm._l((_vm.list),function(item,index){return _c('bd-cell-item',{key:index,attrs:{"item":item}})}),_vm._v(" "),(_vm.discount && !_vm.stopHd)?_c('div',{staticClass:"discount-box"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tariff/bd-cell/index.vue?vue&type=template&id=21b87e64&scoped=true
// module id = null
// module chunks = 